import { Toaster as Sonner, toast } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	// In CRA we default to light theme (no next-themes)
	const theme = 'light';

	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			// Sonner inyecta su CSS sin @layer, así que en Tailwind 4 gana a las clases de color
			// de abajo (que viven en @layer utilities). Fondo, texto y borde van por sus variables
			// CSS, como hace shadcn en su versión para Tailwind 4.
			style={
				{
					'--normal-bg': 'var(--popover)',
					'--normal-text': 'var(--popover-foreground)',
					'--normal-border': 'var(--control-border)'
				} as React.CSSProperties
			}
			toastOptions={{
				classNames: {
					// bg-popover/border-control-border, no bg-background/border-border:
					// mismo motivo que ui/Toast — un toast es un panel flotante, no
					// la página (defecto 3, Foundations/DarkMode).
					toast:
						'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-control-border group-[.toaster]:shadow-lg',
					description: 'group-[.toast]:text-muted-foreground',
					actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
					cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
				}
			}}
			{...props}
		/>
	);
};

export { Toaster, toast };
